"use strict";

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _unmutable = _interopRequireDefault(require("./internal/unmutable"));

var _entries = _interopRequireDefault(require("./entries"));

var _default = (0, _unmutable["default"])({
  name: "values",
  immutable: "values",
  record: function record() {
    return function (value) {
      return value.toSeq().values();
    };
  },
  // $FlowFixMe - flow can't deal with computed properties
  array: function array() {
    return function (value) {
      return value[Symbol.iterator]();
    };
  },
  // $FlowFixMe - using * as flow cannot recognise Symbol.iterator as being @@iterator (see https://github.com/facebook/flow/issues/1163)
  all: function all() {
    return function (value) {
      var _ref;

      var entryIterator = (0, _entries["default"])()(value);
      return _ref = {}, (0, _defineProperty2["default"])(_ref, Symbol.iterator, function () {
        return this;
      }), (0, _defineProperty2["default"])(_ref, "next", function next() {
        var entry = entryIterator.next();
        return entry.done ? entry : {
          done: false,
          value: entry.value[1]
        };
      }), _ref;
    };
  }
});

exports["default"] = _default;